// The amount of items to fetch when fetching the main data for options
export const DEFAULT_LIMIT = 100;
